import styled from 'styled-components';

export const Card = styled.div`
  background-color: var(--ui-surface);
  border: 2px solid var(--brand-primary);
  border-radius: var(--border-radius-large);
  padding: var(--space-5);
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  gap: var(--space-5);

  &:hover {
    border-color: var(--brand-primary-hover);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-3);
`;

export const CardTitle = styled.h2`
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-bold);
  color: var(--brand-primary);
  margin: 0;
  line-height: var(--line-height-h2);
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  flex: 1;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  margin-top: var(--space-3);
  padding-top: var(--space-3);
  border-top: 1px solid var(--ui-divider);
`;

export const MetricCard = styled.div`
  background-color: var(--ui-surface-alt);
  border: 2px solid var(--brand-primary);
  border-radius: var(--border-radius-large);
  padding: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-height: 120px;
  justify-content: center;
  text-align: center;

  &:hover {
    border-color: var(--brand-primary-hover);
  }
`;

export const MetricValue = styled.div`
  font-size: var(--font-size-metric-large);
  font-weight: var(--font-weight-bold);
  color: var(--text-black);
  line-height: var(--line-height-metric-large);
`;

export const MetricValueMedium = styled.div`
  font-size: var(--font-size-metric-medium);
  font-weight: var(--font-weight-bold);
  color: var(--text-black);
  line-height: var(--line-height-metric-medium);
`;

export const MetricTitle = styled.h3`
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-bold);
  color: var(--brand-primary);
  margin: 0;
  line-height: var(--line-height-h2);
`;

export const MetricSubtitle = styled.div`
  font-size: var(--font-size-fine);
  color: var(--text-secondary);
  line-height: var(--line-height-fine);
`;

